import { Component, JSX } from "react";
import { appContext } from "../../../AppContext";
import Header, { IProps as IHeaderProps } from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import "./Styles.scss";
import { ProgressIndicatorIndeterminate } from "@serendie/ui";
import { ApiErrorDialog } from "@iconics/components";

export class Layout extends Component<IProps, IState>
{
    private get appContext() { return appContext(); }
    private get appState() { return appContext().state; }

    constructor(props: IProps)
    {
        super(props);

        this.state =
        {
            isPrivate: props.isPrivate,
            isLoading: false,
            showApiError: false,
            apiErrorTitle: '',
            apiErrorDetails: '',
            apiErrorMessages: [],
            apiErrorStatus: 0,
            apiErrorInstance: '',
            apiErrorTime: '',
        };
    }

    public componentDidMount(): void
    {
        this.appState.autoMap(this, i => ({
            isLoading: i.isLoading,
            showApiError: i.showApiError,
            apiErrorTitle: i.apiErrorTitle,
            apiErrorDetails: i.apiErrorDetails,
            apiErrorMessages: i.apiErrorMessages,
            apiErrorStatus: i.apiErrorStatus,
            apiErrorInstance: i.apiErrorInstance,
            apiErrorTime: i.apiErrorTime,
        }));
    }

    public render(): JSX.Element
    {
        return (
            <>
                {
                    this.state.isPrivate &&
                    <div className="page-container layout">
                        <Sidebar {...this.props} />
                        <div>
                            <div className="rightPanel">
                                <header>
                                    <Header {...this.props as unknown as IHeaderProps} />
                                </header>
                                <main id="main-content" className="main-content">
                                    {this.props.children}
                                </main>
                                <div className={`layout__progress-indicator ${this.state.isLoading ? 'layout__progress-indicator--show' : 'layout__progress-indicator--hide'}`}>
                                    <div className='layout__progress-indicator-backdrop' />
                                    <ProgressIndicatorIndeterminate
                                        className='layout__progress-indicator-spinner'
                                        type='circular'
                                        size='large'
                                        color='subtle'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {!this.state.isPrivate && this.props.children}
                <ApiErrorDialog
                    show={this.state.showApiError}
                    errorTitle={this.state.apiErrorTitle}
                    errorDetails={this.state.apiErrorDetails}
                    messages={this.state.apiErrorMessages}
                    status={this.state.apiErrorStatus}
                    instance={this.state.apiErrorInstance}
                    time={this.state.apiErrorTime}
                    onClose={() => appContext().state.set({ showApiError: false })}
                />
            </>);
    }
}

export default Layout;

interface IProps
{
    isPrivate: boolean;
    children?: React.ReactNode;
}

interface IState
{
    isPrivate: boolean;
    isLoading: boolean;
    showApiError: boolean;
    apiErrorTitle: string;
    apiErrorDetails: string;
    apiErrorMessages: string[];
    apiErrorStatus: number;
    apiErrorInstance: string;
    apiErrorTime: string;
}
